export class SystemMaintanceModel {
  title = '';
  description = '';
  type = '';
}
